'use client';

import {useSelector} from 'react-redux';

import type {ProductProps} from '@/molecules/Cards/Product/typings';
import type Props from './typings';

import useAuth from '@/hooks/use-auth/use-auth';
import useExponeaRecommendations from '@/hooks/use-exponea-recommendations/use-exponea-recommendations';
import ProductFeed from '@/organisms/ProductFeed/ProductFeed';
import {StyledColorBlock} from '@/pages/styles';
import {selectUserSettingsData} from '@/redux/reducers/userSettingsReducer';

const MoreLikeThisSection = ({recommendationId, background}: Props): JSX.Element | null => {
  const auth = useAuth();
  const userEmail = (auth.getUserEmail() || undefined) as string | undefined;
  const settings = useSelector(selectUserSettingsData);
  const productRecommendations = useExponeaRecommendations({
    recommendationId,
    userEmail,
    size: 4,
    displaySizeUnits: settings.display_units,
  });

  if (productRecommendations.data.length === 0) {
    return null;
  }
  return (
    <StyledColorBlock $background={background} aria-label="More like this products section">
      <ProductFeed
        /* Type casting to serve the raw data from BloomReach for now  */
        products={productRecommendations.data as unknown as ProductProps[]}
        title="More like this"
      />
    </StyledColorBlock>
  );
};

export default MoreLikeThisSection;
